/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { ClientId } from '../../models/client-id';
import { FareRuleCategory } from '../../models/fare-rule-category';
import { FareRules } from '../../models/fare-rules';

export interface GetFareRulesByCart$Params {
  cartId: string;
  travelerId: string;
  ruleCategory: FareRuleCategory;
  hash?: string;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
}

export function getFareRulesByCart(http: HttpClient, rootUrl: string, params: GetFareRulesByCart$Params, context?: HttpContext): Observable<DapiHttpResponse<FareRules>> {
  const rb = new DapiRequestBuilder(rootUrl, getFareRulesByCart.PATH, 'get');

  if (params) {
    rb.path('cartId', params.cartId, {});
    rb.query('travelerId', params.travelerId, {});
    rb.query('ruleCategory', params.ruleCategory, {});
    rb.query('hash', params.hash, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FareRules>;
    }),
    catchErrorAsJson()
  );
}

getFareRulesByCart.PATH = '/api/v2/cart/{cartId}/rules';
